import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
export const fetchLeaveEntryApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.LeaveEntry.leave_list}`,
        {
            params: payload,
        }
    );
}
export const updateLeaveApprovalApi = async (id, payload) =>{
    return await api.put(
        `${apiPath.API_URL}${apiPath.Approval.leave_approval}/${id}`,
        payload
    );
};
export const getManualEntryApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.ManualEntry.list}`,
        {params: payload},
    );
};
export const updateManualApprovalApi = async (id, payload) => {
    return await api.put(
        `${apiPath.API_URL}${apiPath.Approval.manual_approval}/${id}`,
        payload
    );
};